export function pickActiveSection(
  sectionTops: readonly number[],
  probeY: number,
  atMaxScroll = false
): number {
  if (sectionTops.length === 0) return -1;

  if (atMaxScroll) return sectionTops.length - 1;

  const roundedProbe = Math.round(probeY);

  let current = 0;
  for (let i = 0; i < sectionTops.length; i += 1) {
    if (Math.round(sectionTops[i]) <= roundedProbe) {
      current = i;
    } else {
      break;
    }
  }

  return current;
}

export function reanchorScrollDelta(
  anchorOffset: number,
  currentTop: number,
  probeY: number
): number {
  return currentTop - probeY - anchorOffset;
}

export function pickStableSection(
  sectionTops: readonly number[],
  sectionBottoms: readonly number[],
  probeY: number,
  viewportBottom: number,
  currentIndex: number,
  atMaxScroll = false
): number {
  const candidate = pickActiveSection(sectionTops, probeY, atMaxScroll);
  if (
    candidate < 0 ||
    atMaxScroll ||
    currentIndex < 0 ||
    currentIndex >= sectionTops.length ||
    candidate === currentIndex
  ) {
    return candidate;
  }

  const visible = (i: number) =>
    Math.max(
      0,
      Math.min(sectionBottoms[i], viewportBottom) -
        Math.max(sectionTops[i], probeY)
    );

  return visible(currentIndex) > visible(candidate) ? currentIndex : candidate;
}
